import { WidgetRegistryEntry, WidgetTemplateComponentFactory } from "@smallstack/widget-core";
import { CustomFieldsCompoundWidgetDefinition } from "@smallstack/widget-shared";

export const CustomFieldsCompoundWidget: WidgetRegistryEntry = {
  name: "CustomFieldsCompound",
  component: async () => WidgetTemplateComponentFactory.withTemplate(CustomFieldsCompoundWidgetDefinition),
  configuration: async () => import("./configuration").then((m) => m.CustomFieldsCompoundWidgetConfiguration)
};
